
import { Component, Vue } from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import PickerDate from '@/components/picker-date.vue';

import {
    employeeOperatorConfigList,
    employeeOperatorConfigDelete
} from '@/api/toBApi';

@Component({
    name: '',
    components: {
        PageFooter,
        PickerDate
    }
})
export default class OperationLog extends Vue {

    private list = [{}];
    private keywords = '';
    private pageNo = 1;
    private pageSize = 20;
    private total = 0;
    private loading = false;


    private mounted() {
        this.getList()
    }

    private doSearch() {
        this.pageNo = 1
        this.getList()
    }
    private changePage(e) {
        this.pageNo = e
        this.getList()
    }
    private async getList() {
        this.loading = true;
        try {
            let params = {
                Keywords: this.keywords.trim(),
                Skip: (this.pageNo - 1) * this.pageSize,
                Take: this.pageSize
            }
            const res: any = await employeeOperatorConfigList(params);
            this.list = res.Result.Results;
            this.total = res.Result.Total;

        } catch (error) {

        } finally {
            this.loading = false;
        }
    }

    private handleToEdit(id) {
        this.$router.push({
            name: 'employeeAccountEdit',
            query: {
                id
            }
        })
    }

    private handleToDelete(record) {
        this.$confirm('是否确认取消该员工登录B端APP的权限？', '提示', {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async () => {
            try {
                await employeeOperatorConfigDelete({Id: record.Id});
                this.$message.success('操作成功');
                this.doSearch();
            } catch (error) {

            } finally {
                
            }
        }).catch(() => {
        });
    }
    // private clearSearch() {

    // }


}
